import { render, staticRenderFns } from "./orderCharteredVehicle.vue?vue&type=template&id=5f4ec025"
import script from "./orderCharteredVehicle.vue?vue&type=script&lang=js"
export * from "./orderCharteredVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports